import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import WordGameEasyMode from '../components/WordGame/WordGameEasyMode';
import WordGameMediumMode from '../components/WordGame/WordGameMediumMode';
import WordGameHardMode from '../components/WordGame/WordGameHardMode';

const WordGamePlay = () => {
    const location = useLocation();
    const [level, setLevel] = useState(null);

    useEffect(() => {
        setLevel(location?.state?.level);
    }, [location?.state]);
    console.log(level, 'l');
    switch (String(level)) {
        case "1":
            return <WordGameEasyMode />

        case "2":
            return <WordGameMediumMode />
        case "3":
            return <WordGameHardMode />
        default: return null
    }
}

export default WordGamePlay